import React, { useContext, useEffect, useState } from 'react'
import { NumberPicker, Balloon } from '@alifd/next'
import ContextManager from "./context-manager";

export default function ItemNumber({data}) {
    // 触发数据更新
    const {postData, skuIds, handleSelect, tipShow, setTipShow, I18n} = useContext(ContextManager);

    // 货币
    const productPriceCurrencySimpleName = '$';

    const {skus, skuInfo} = postData

    const renderNumber = item => {
        let selectSku = {}
        if (skuInfo.length === 1) {
            selectSku = skus[item.id]
        }else 
        if (skuIds){
            selectSku = skus[[skuIds, item.id].join('-')]
        }
        return <div className="item-type" key={item.id}>
                <div className="type">
                    {item.type === 'IMAGE' && <img src={item.smallImage} />}
                    {item.type === 'TEXT' && item.name}
                    {item.type === 'COLOR' && <span style={{
                        backgroundColor: item.color
                    }}></span>}
                </div>
                <div className="price">
                    {productPriceCurrencySimpleName} {selectSku.price}</div>
                <div className="number sku-number"><NumberPicker min={0} style={{
                    width: "100px"
                }} defaultValue={0} type="inline" onChange={n => {
                    handleSelect('number', item.id, n)
                }}/></div>
        </div>
    }

    return data && (
        <Balloon trigger={<div className="sku-item">
        <label>{data.name}:</label>
       <div className="item-list">
            {data.values.map(sku => renderNumber(sku))}
        </div>
    </div>} align="t" className="tip-show" alignEdge visible={tipShow} onClose={() => setTipShow(false)} triggerType="hover" style={{
            width: 300,
            backgroundColor: '#333',
            color: '#fff'
        }}>
            {I18n.get('strongWarningText1')} {data.name}
        </Balloon>
    )
}
